function formatYYYYMMDD(d: Date): string {
  const YYYY = `${d.getFullYear()}`;
  const MM = (d.getMonth() + 1).toString().padStart(2, "0");
  const DD = d.getDate().toString().padStart(2, "0");
  return `${YYYY}${MM}${DD}`;
}

export function nameCsvFile(resourceName: string): string {
  return `${resourceName}.csv`;
}

export function nameCsvFileWithTerm(
  resourceName: string,
  term: { from?: Date; to?: Date },
): string {
  let fileName: string = resourceName;
  if (term.from) {
    fileName += "-" + formatYYYYMMDD(term.from);
  }
  if (term.to) {
    fileName += "-" + formatYYYYMMDD(term.to);
  }
  return `${fileName}.csv`;
}

export function nameCsvFileWithResourceId(
  resourceName: string,
  resourceId: string,
): string {
  return `${resourceName}-${resourceId}.csv`;
}
